var map = {
	"./banner-accident.jpg": "e182",
	"./banner-car.jpg": "3d1c",
	"./banner-index-1.jpg": "4ceb",
	"./banner-motor.jpg": "7e37",
	"./banner-pet.jpg": "68e5",
	"./banner-pet0.jpg": "24c7",
	"./banner-travel.jpg": "69d5",
	"./banner-vaccine.jpg": "13c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5078";